const RawLeadStructure = [
  {
    text: 'PERSONAL',
    icon: 'mdi-account',
    children: [
      { text: 'REQUESTEDAMOUNT' },
      { text: 'SSN' },
      { text: 'DOB' },
      { text: 'FIRSTNAME' },
      { text: 'MIDDLEINITAL' },
      { text: 'LASTNAME' },
      { text: 'ADDRESS' },
      { text: 'ADDRESS2' },
      { text: 'CITY' },
      { text: 'STATE' },
      { text: 'ZIP' },
      { text: 'HOMEPHONE' },
      { text: 'OTHERPHONE' },
      { text: 'DLSTATE' },
      { text: 'DLNUMBER' },
      { text: 'CONTACTTIME' },
      { text: 'ADDRESSMONTHS' },
      { text: 'ADDRESSYEARS' },
      { text: 'RENTOROWN' },
      { text: 'ISMILITARY' },
      { text: 'ISCITIZEN' },
      { text: 'OTHEROFFERS' },
      { text: 'EMAIL' },
      { text: 'AGE' }
    ]
  }, {
    text: 'EMPLOYMENT',
    icon: 'mdi-briefcase',
    children: [
      { text: 'INCOMETYPE' },
      { text: 'PAYTYPE' },
      { text: 'EMPMONTHS' },
      { text: 'EMPYEARS' },
      { text: 'EMPNAME' },
      { text: 'EMPPHONE' },
      { text: 'EMPPHONEEXT' },
      { text: 'HIREDATE' },
      { text: 'EMPTYPE' },
      { text: 'JOBTITLE' },
      { text: 'PAYFREQUENCY' },
      { text: 'NETMONTHLY' },
      { text: 'LASTPAYDATE' },
      { text: 'NEXTPAYDATE' },
      { text: 'SECONDPAYDATE' }
    ]
  }, {
    text: 'BANK',
    icon: 'mdi-bank',
    children: [
      { text: 'ACCOUNTHOLDER' },
      { text: 'BANKNAME' },
      { text: 'ACCOUNTTYPE' },
      { text: 'ROUTINGNUMBER' },
      { text: 'ACCOUNTNUMBER' },
      { text: 'BANKMONTHS' },
      { text: 'BANKYEARS' },
      { text: 'ACTIVECHECKING' }
    ]
  }
]

export default RawLeadStructure
